/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateQuizQuestionCommand } from '../model/createQuizQuestionCommand';
import { CreateQuizQuestionCommandResult } from '../model/createQuizQuestionCommandResult';
import { DeleteQuizQuestionCommandResult } from '../model/deleteQuizQuestionCommandResult';
import { GetQuizQuestionQueryResult } from '../model/getQuizQuestionQueryResult';
import { GetQuizQuestionsQueryResult } from '../model/getQuizQuestionsQueryResult';
import { InlineResponse404 } from '../model/inlineResponse404';
import { QuizQuestionStructureType } from '../model/quizQuestionStructureType';
import { QuizQuestionType } from '../model/quizQuestionType';
import { ResourceScopeType } from '../model/resourceScopeType';
import { UpdateQuizQuestionCommand } from '../model/updateQuizQuestionCommand';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class QuizQuestionsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param filterExcludedQuestions 
     * @param filterCreatedByUserUids 
     * @param filterScopeType 
     * @param filterTeamUid 
     * @param filterStructureType 
     * @param filterQuizQuestionType 
     * @param bundleUid 
     * @param pageNumber 
     * @param pageSize 
     * @param searchText 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public quizQuestionsGet(filterExcludedQuestions?: Array<string>, filterCreatedByUserUids?: Array<string>, filterScopeType?: ResourceScopeType, filterTeamUid?: string, filterStructureType?: QuizQuestionStructureType, filterQuizQuestionType?: QuizQuestionType, bundleUid?: string, pageNumber?: number, pageSize?: number, searchText?: string, observe?: 'body', reportProgress?: boolean): Observable<GetQuizQuestionsQueryResult>;
    public quizQuestionsGet(filterExcludedQuestions?: Array<string>, filterCreatedByUserUids?: Array<string>, filterScopeType?: ResourceScopeType, filterTeamUid?: string, filterStructureType?: QuizQuestionStructureType, filterQuizQuestionType?: QuizQuestionType, bundleUid?: string, pageNumber?: number, pageSize?: number, searchText?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetQuizQuestionsQueryResult>>;
    public quizQuestionsGet(filterExcludedQuestions?: Array<string>, filterCreatedByUserUids?: Array<string>, filterScopeType?: ResourceScopeType, filterTeamUid?: string, filterStructureType?: QuizQuestionStructureType, filterQuizQuestionType?: QuizQuestionType, bundleUid?: string, pageNumber?: number, pageSize?: number, searchText?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetQuizQuestionsQueryResult>>;
    public quizQuestionsGet(filterExcludedQuestions?: Array<string>, filterCreatedByUserUids?: Array<string>, filterScopeType?: ResourceScopeType, filterTeamUid?: string, filterStructureType?: QuizQuestionStructureType, filterQuizQuestionType?: QuizQuestionType, bundleUid?: string, pageNumber?: number, pageSize?: number, searchText?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {











        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filterExcludedQuestions) {
            filterExcludedQuestions.forEach((element) => {
                queryParameters = queryParameters.append('Filter.ExcludedQuestions', <any>element);
            })
        }
        if (filterCreatedByUserUids) {
            filterCreatedByUserUids.forEach((element) => {
                queryParameters = queryParameters.append('Filter.CreatedByUserUids', <any>element);
            })
        }
        if (filterScopeType !== undefined && filterScopeType !== null) {
            queryParameters = queryParameters.set('Filter.ScopeType', <any>filterScopeType);
        }
        if (filterTeamUid !== undefined && filterTeamUid !== null) {
            queryParameters = queryParameters.set('Filter.TeamUid', <any>filterTeamUid);
        }
        if (filterStructureType !== undefined && filterStructureType !== null) {
            queryParameters = queryParameters.set('Filter.StructureType', <any>filterStructureType);
        }
        if (filterQuizQuestionType !== undefined && filterQuizQuestionType !== null) {
            queryParameters = queryParameters.set('Filter.QuizQuestionType', <any>filterQuizQuestionType);
        }
        if (bundleUid !== undefined && bundleUid !== null) {
            queryParameters = queryParameters.set('BundleUid', <any>bundleUid);
        }
        if (pageNumber !== undefined && pageNumber !== null) {
            queryParameters = queryParameters.set('PageNumber', <any>pageNumber);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>pageSize);
        }
        if (searchText !== undefined && searchText !== null) {
            queryParameters = queryParameters.set('SearchText', <any>searchText);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetQuizQuestionsQueryResult>('get',`${this.basePath}/QuizQuestions`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public quizQuestionsPost(body?: CreateQuizQuestionCommand, observe?: 'body', reportProgress?: boolean): Observable<CreateQuizQuestionCommandResult>;
    public quizQuestionsPost(body?: CreateQuizQuestionCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CreateQuizQuestionCommandResult>>;
    public quizQuestionsPost(body?: CreateQuizQuestionCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CreateQuizQuestionCommandResult>>;
    public quizQuestionsPost(body?: CreateQuizQuestionCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CreateQuizQuestionCommandResult>('post',`${this.basePath}/QuizQuestions`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public quizQuestionsUidDelete(uid: string, observe?: 'body', reportProgress?: boolean): Observable<DeleteQuizQuestionCommandResult>;
    public quizQuestionsUidDelete(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DeleteQuizQuestionCommandResult>>;
    public quizQuestionsUidDelete(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DeleteQuizQuestionCommandResult>>;
    public quizQuestionsUidDelete(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling quizQuestionsUidDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<DeleteQuizQuestionCommandResult>('delete',`${this.basePath}/QuizQuestions/${encodeURIComponent(String(uid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public quizQuestionsUidGet(uid: string, observe?: 'body', reportProgress?: boolean): Observable<GetQuizQuestionQueryResult>;
    public quizQuestionsUidGet(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetQuizQuestionQueryResult>>;
    public quizQuestionsUidGet(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetQuizQuestionQueryResult>>;
    public quizQuestionsUidGet(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling quizQuestionsUidGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetQuizQuestionQueryResult>('get',`${this.basePath}/QuizQuestions/${encodeURIComponent(String(uid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public quizQuestionsUidPut(uid: string, body?: UpdateQuizQuestionCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public quizQuestionsUidPut(uid: string, body?: UpdateQuizQuestionCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public quizQuestionsUidPut(uid: string, body?: UpdateQuizQuestionCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public quizQuestionsUidPut(uid: string, body?: UpdateQuizQuestionCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling quizQuestionsUidPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/QuizQuestions/${encodeURIComponent(String(uid))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
